module.exports = __webpack_public_path__ + "img/logo-frontal.bc75cc8e.png";